export const initInputsValidation = () => {
  const formsWithValidation: NodeListOf<HTMLTextAreaElement> = document.querySelectorAll(
    ".forbidden-words-validation",
  );

  formsWithValidation.forEach((input) => {
    input.addEventListener("keyup", (e) => {
      const currentTarget = e.target as HTMLTextAreaElement;
      const content = currentTarget.value;

      currentTarget.value = content.replace(/http:\/\/|https:\/\//gi, "");
    });
  });
};
